export default __webpack_public_path__ + "static/media/id_2022.540fb0fa.png";